import React from 'react';

const BOX = 'flex gap-3 items-start p-4 rounded-xl border cursor-pointer text-[15px] leading-snug';

export const BetaCheck = ({ id, checked, onChange, children, highlight }) => (
  <label className={`${BOX} ${highlight ? 'border-amber-300 bg-amber-50' : 'border-[#D9E2EB] bg-white'}`}>
    <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#0A7A55] shrink-0" data-testid={`beta-check-${id}`} />
    <span className="text-[#0E2340]">{children}</span>
  </label>
);

export const BetaAgreement = ({ terms }) => (
  <section className="mt-12">
    <h2 className="beta-display text-2xl sm:text-3xl font-extrabold text-[#0E2340]">The agreement</h2>
    <ol className="mt-5 bg-white border border-[#D9E2EB] rounded-2xl p-5 sm:p-6 space-y-3.5 text-[15px] text-[#0E2340] leading-relaxed" data-testid="beta-terms-list">
      {(terms || []).map((t, i) => <li key={i}>{i + 1}. {t}</li>)}
    </ol>
  </section>
);
